import { useContext } from "react";

import { HRAuthContext } from "../context/hrcustomauth";

export const useHRAuth = () => {
    const context = useContext(HRAuthContext);
    if (!context) {
      throw new Error('useHRAuth must be used within a HrProvider');
    }
    return context;
  };